import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { func } from 'prop-types';

import { Icon } from '@atoms';
import { storage } from '@utils';
import { ONBOARDING_BANNER_KEY, ONBOARDING_ROUTES_BY_STEPS } from '@constants/common';
import { routes } from '@constants';
import { Button, Flex, Typography } from '@mixins';
import { theme } from '@styles';

import { ReactComponent as CloseIcon } from '@assets/svgs/Close.svg';
import { ReactComponent as OnboardingCheckList } from '@assets/svgs/OnboardingCheckList.svg';

const OnboardingBanner = ({ onClose }) => {
  const history = useHistory();

  const { onboardingState } = useSelector(store => store.companyStore);

  const handleFinalizeClick = () => {
    history.push(
      onboardingState?.isSubmitted ? routes.startOnboarding : ONBOARDING_ROUTES_BY_STEPS[onboardingState.currentStep],
    );
  };

  const handleBannerClose = () => {
    onClose();

    storage.setToLocalStorage(ONBOARDING_BANNER_KEY, new Date().toISOString());
  };

  return (
    <Flex
      width="100%"
      height={['50px', '54px', '58px']}
      justifyContent="space-between"
      alignItems="center"
      backgroundColor={theme.color.pinkMinded[300]}
      px={[35, 48, 60]}>
      <Flex flex={1} justifyContent="center" alignItems="center">
        <Icon SVG={OnboardingCheckList} width={['30px', '40px', '50px']} height={['30px', '40px', '50px']} mr="10px" />
        <Typography
          mr={['20px', '30px', '40px']}
          variant="diatype-500"
          fontSize={['10px', '12px', '18px', '24px']}
          color={theme.color.mintMinded[900]}>
          You&apos;re almost ready to move-in!
        </Typography>
        <Button
          onClick={handleFinalizeClick}
          py={['3px', '6px']}
          px={('6px', '10px')}
          mr="10px"
          variant="secondary"
          fontSize={[10, 12, 14, 16]}>
          {onboardingState?.isSubmitted ? 'Update' : 'Finalize'} move-in details
        </Button>
      </Flex>
      <Icon pointer onClick={handleBannerClose} SVG={CloseIcon} width={[10, 13, 16]} height={[10, 13, 16]} />
    </Flex>
  );
};

OnboardingBanner.propTypes = {
  onClose: func.isRequired,
};

export default OnboardingBanner;
